declare namespace angular {
    export interface IFilterService {
        (name: 'accentInsensitiveFilter'): app.support.IFilterAccentInsensitiveFilter;
    }
}

namespace app.support {

    declare let angular: ng.IAngularStatic;

    export interface IFilterAccentInsensitiveFilter {
        <T>(array: T[], expression: string | ng.IFilterFilterPatternObject | ng.IFilterFilterPredicateFunc<T>): T[];
    }

    function hasCustomToString(obj) {
        return angular.isFunction(obj.toString) && obj.toString !== Object.prototype.toString;
    }

    /** @ngInject */
    function filterAccentInsensitiveFilter($filter: ng.IFilterService) {
        return (array, expression) => {
            return $filter("filter")(array, expression, (actual: any, expected: any) => {
                if (angular.isUndefined(actual)) {
                    // No substring matching against `undefined`
                    return false;
                }
                if ((actual === null) || (expected === null)) {
                    // No substring matching against `null`; only match against `null`
                    return actual === expected;
                }
                if (angular.isObject(expected) || (angular.isObject(actual) && !hasCustomToString(actual))) {
                    // Should not compare primitives against objects, unless they have custom `toString` method
                    return false;
                }

                actual = _.deburr(angular.lowercase('' + actual));
                expected = _.deburr(angular.lowercase('' + expected));
                return actual.indexOf(expected) !== -1;
            });
        }
    }

    angular.module('app.support').filter('accentInsensitiveFilter', filterAccentInsensitiveFilter);
}